import { sanitizeText, containsSuspiciousCode } from './sanitize';

/**
 * Sanitiza a entrada do usuário, mas apenas se não for uma mensagem confiável
 * @param {string} input - Texto a ser sanitizado
 * @param {boolean} isTrusted - Se a mensagem vem de uma fonte confiável (botão da interface)
 * @returns {string} - Texto sanitizado ou original se for confiável
 */
const sanitizeInput = (input, isTrusted = false) => {
  // Se a mensagem for de uma fonte confiável, retorne sem sanitizar
  if (isTrusted) {
    return input;
  }
  
  // Caso contrário, sanitize a entrada
  return sanitizeText(input);
};

/**
 * Verifica se a entrada é válida (não contém código malicioso)
 * @param {string} input - Texto a ser verificado
 * @param {boolean} isTrusted - Se a mensagem vem de uma fonte confiável (botão da interface)
 * @returns {boolean} - True se a entrada for válida
 */
export const isValidInput = (input, isTrusted = false) => {
  // Se a mensagem for de uma fonte confiável, sempre é válida
  if (isTrusted) {
    return true;
  }
  
  // Caso contrário, verifique se contém código suspeito
  return !containsSuspiciousCode(input);
};

/**
 * Verifica se uma mensagem está na lista de mensagens confiáveis
 * @param {string} message - Mensagem a ser verificada
 * @param {Array<string>} trustedMessages - Lista de mensagens confiáveis
 * @returns {boolean} - True se a mensagem for confiável
 */
export const isTrustedMessage = (message, trustedMessages) => {
  return trustedMessages.includes(message);
};

/**
 * Sanitiza HTML apenas se não for de uma fonte confiável
 * @param {string} html - HTML a ser sanitizado
 * @param {boolean} isTrusted - Se o HTML vem de uma fonte confiável
 * @returns {string} - HTML sanitizado ou original se for confiável
 */
export const sanitizeHtmlConditional = (html, isTrusted = false) => {
  if (isTrusted) {
    return html;
  }
  
  // Use DOMPurify ou outra biblioteca para sanitizar HTML
  // Este é um exemplo simplificado
  const tempElement = document.createElement('div');
  tempElement.textContent = html;
  return tempElement.innerHTML;
};

export default sanitizeInput; 